import { render, staticRenderFns } from "./cGuiHua.vue?vue&type=template&id=7849872d&scoped=true&"
import script from "./cGuiHua.vue?vue&type=script&lang=js&"
export * from "./cGuiHua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7849872d",
  null
  
)

export default component.exports